import { useDisclosure } from '@ds';
import { noop } from 'lodash-es';
import { CaseStatus, ReallocationData, TrialAnsweredQuestionModel, TrialQuestion } from '@/api/apis/case';
import { TrialProgram } from '@/api/apis/facilities/trial-programs';
import { TrialQuestionnaireResultsModal } from './TrialQuestionnaireResultsModal';
import { trialAnswerNames } from '@/constants/case/case.constants';
import SectionRow from '../SectionRow';
import { Uuid } from '@/api/types';

type TrialQuestionnaireResultsProps = {
  caseId: Uuid;
  hasEditPermission: boolean;
  reallocationData: ReallocationData | null | undefined;
  caseStatus: CaseStatus;
  trialProgram?: TrialProgram;
  questionnaire?: TrialAnsweredQuestionModel[];
};

export const preferredScsQuestions = [
  TrialQuestion.DenovoColdStaticPreservationConfirmation,
  TrialQuestion.EnhanceColdStaticPreservationConfirmation,
];

export const TrialQuestionnaireResults = ({
  trialProgram,
  reallocationData,
  questionnaire,
  caseId,
  caseStatus,
  hasEditPermission,
}: TrialQuestionnaireResultsProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  if (!questionnaire?.length || !trialProgram) return null;

  const answers = questionnaire
    .map((q) =>
      preferredScsQuestions.includes(q.question)
        ? `Preferred: ${trialAnswerNames[q.answer]}`
        : trialAnswerNames[q.answer],
    )
    .join('; ');

  const customAnswers = questionnaire
    .map((q) => q.customAnswer)
    .filter(Boolean)
    .join('; ');

  return (
    <SectionRow truncate={false} label={`${trialProgram.name} Program`}>
      <div tabIndex={0} onKeyDown={noop} role="button" onClick={onOpen} className="text-m-m! underline">
        {answers}
      </div>
      {customAnswers && <div className="text-xs-r mt-1">{customAnswers}</div>}
      {isOpen && (
        <TrialQuestionnaireResultsModal
          caseId={caseId}
          caseStatus={caseStatus}
          onClose={onClose}
          trialProgram={trialProgram}
          questionnaire={questionnaire}
          reallocationData={reallocationData}
          hasEditPermission={hasEditPermission}
        />
      )}
    </SectionRow>
  );
};
